import React, { ReactElement, useRef, useState } from "react";

import DashboardLayout from "@/components/Layouts/DashboardLayout";
import ContentWrapper from "@/components/utils/ContentWrapper";
import GenericObjectList from "@/components/utils/GenericObjectList";
import { useAppSelector } from "@/lib/hooks";
import { DataGridActionProps, NextPageWithLayout } from "@/lib/types";
import { DownloadIcon } from "@chakra-ui/icons";
import { Flex, MenuItem } from "@chakra-ui/react";
import Head from "next/head";
import { CSVLink } from "react-csv";

const AssetCategories: NextPageWithLayout = () => {
  const { client } = useAppSelector((s) => s.apiData.favourite);

  return (
    <>
      <Head>
        <title>Admin | Asset Categories</title>
      </Head>
      <ContentWrapper p={0}>
        <Flex w="full" direction="column">
          <GenericObjectList
            additionalActions={[CsvExportAction]}
            defaultHiddenColumns={["order"]}
            apiRoot={`client/${client}/categoryAsset`}
            allowCreate={true}
          />
        </Flex>
      </ContentWrapper>
    </>
  );
};

AssetCategories.getLayout = function getLayout(page: ReactElement) {
  return <DashboardLayout>{page}</DashboardLayout>;
};

export default AssetCategories;

const CsvExportAction = (props: DataGridActionProps) => {
  const csvRef = useRef(null);
  const [csv, setCsv] = useState<Array<{ [key: string]: string | number }>>([]);
  const { clients, suppliers } = useAppSelector((state) => state.apiData);
  const { rows, selectedRows } = props;

  return (
    <>
      <CSVLink
        ref={csvRef}
        data={csv}
        asyncOnClick
        onClick={() => {}}
        filename={"Export.csv"}
      />
      <MenuItem
        icon={<DownloadIcon fill="gray" />}
        onClick={async () => {
          console.clear();
          const tempCsv: Array<{ [key: string]: string | number }> = [];
          selectedRows.map((row) => {
            const temp: { [key: string]: string | number } = {};
            const findRow = rows.find((r) => r.values.id === row);
            if (!findRow) return false;
            const r = findRow.values;
            temp["id"] = r.id;
            temp["name"] = r.name;
            tempCsv.push(temp);
          });
          await setCsv(tempCsv);
          csvRef?.current?.link?.click();
        }}
        isDisabled={selectedRows.length === 0}
      >
        CSV Export
      </MenuItem>
    </>
  );
};
